export default __webpack_public_path__ + "static/media/photo-5.8f8d6c14.jpg";